/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcCasesV1CaseState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_CASES_V1_CASE_STATE_ENTITY_NAME = 'ixc.cases.v1.Case';
export const ixcCasesV1CaseStateEntity = new schema.Entity<IxcCasesV1CaseState>(IXC_CASES_V1_CASE_STATE_ENTITY_NAME, {}, { idAttribute: 'caseId' });

